if (!customElements.get('product-card-popup')) {
  customElements.define(
    'product-card-popup',
    class extends HTMLElement {
      constructor() {
        super();
        this.boundInit = this.initialize.bind(this);
        this.boundHandleWindowClick = this.handleWindowClick.bind(this);
        this.boundHandleOverlayClick = this.handleOverlayClick.bind(this);
      }

      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.boundInit, { once: true });
          return;
        }
        this.initialize();
      }

      initialize() {
        this.overlayTriggers = this.querySelectorAll('.overlay-trigger');
        this.countriesCoveredArray = this.dataset.countries
          ? this.dataset.countries.split('|')
          : [];
        this.overlayTriggers?.forEach((trigger) => {
          trigger.addEventListener('click', this.boundHandleOverlayClick);
        });

        window.addEventListener('click', this.boundHandleWindowClick);
      }

      handleWindowClick(event) {
        const overlays = document.querySelectorAll('.overlay');
        overlays.forEach((overlay) => {
          if (event.target === overlay) {
            this.handleOverlayClose(overlay, event);
          }
        });
      }

      handleOverlayClick(event) {
        event.stopPropagation();

        const overlayId = event.target.getAttribute('data-overlay-target');
        if (!overlayId) return;

        const overlayElement = document.getElementById(overlayId);
        if (!overlayElement) return;

        if (overlayId === 'countriesCovered') {
          this.generateCountriesCoveredMarkup(overlayElement);
        } else if (overlayId === 'homeNumber') {
          this.displayOverlayElement(overlayElement);
        }

        const closeBtn = overlayElement.querySelector('.close-btn');
        if (closeBtn) {
          if (closeBtn._boundClose) {
            closeBtn.removeEventListener('click', closeBtn._boundClose);
          }
          closeBtn._boundClose = this.handleOverlayClose.bind(this, overlayElement);
          closeBtn.addEventListener('click', closeBtn._boundClose);
        }
      }

      displayOverlayElement(overlayElement) {
        overlayElement.classList.add('active');
        document.body.classList.add('modal-open');
      }

      handleOverlayClose(overlayElement, event) {
        if (!overlayElement.classList.contains('active')) return;
        overlayElement.classList.remove('active');
        document.body.classList.remove('modal-open');
      }

      handleize(str) {
        return str
          .toString()
          .toLowerCase()
          .trim()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(/[^a-z0-9\-]/g, '') // Remove all non-alphanumeric chars (except dashes)
          .replace(/\-{2,}/g, '-') // Replace multiple dashes with a single -
          .replace(/^-+/, '') // Trim dashes from the start
          .replace(/-+$/, '');
      }

      generateCountriesCoveredMarkup(overlayElement) {
        const countriesCoveredList = overlayElement.querySelector('.countries-covered-list ul');
        countriesCoveredList.replaceChildren();
        const fragment = document.createDocumentFragment();
        this.countriesCoveredArray.forEach((country, i) => {
          const li = document.createElement('li');
          li.id = this.handleize(country);
          const img = document.createElement('img');
          img.src = `https://cdn.shopify.com/s/files/1/0582/6081/6062/files/${this.handleize(country)}.svg`;
          img.alt = `${country} Flag`;
          img.classList.add('flag-svg');
          li.innerText = country;
          li.append(img);
          fragment.append(li);
        });

        const viewPlanBtn = overlayElement.querySelector('.overlay-plan-btn');
        if (viewPlanBtn) {
          viewPlanBtn.setAttribute('href', this.dataset.url);
        }

        overlayElement.querySelector('.countries-covered-title').innerText =
          this.dataset.productTitle || '';

        countriesCoveredList.append(fragment);
        this.displayOverlayElement(overlayElement);
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.boundInit);
        this.overlayTriggers.forEach((trigger) => {
          trigger.removeEventListener('click', this.boundHandleOverlayClick);
        });
        window.removeEventListener('click', this.boundHandleWindowClick);
      }
    },
  );
}
